
import React from 'react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { ContextualMenuItemType } from 'office-ui-fabric-react/lib/ContextualMenu';

import { setBaseLayerVisibility, setOverLayerVisibility } from './setVisibility';

function getMenuProps(layers, groups, onMenuItemClick) {
    let items = [];
    groups.forEach(group => {
        let groupItems = [];
        group.layers.forEach(layerId => {
            layers.forEach(layer => {
                if (layer.id === layerId) {
                    groupItems.push({
                        key: layer.id,
                        text: layer.title,
                        layer: layer,
                        onClick: onMenuItemClick,
                        iconProps: {
                            iconName: layer.visible ? 'CheckMark' : ''
                        },
                    });
                }
            })
        });

        items.push({
            key: group.id,
            itemType: ContextualMenuItemType.Section,
            sectionProps: {
                title: group.title,
                items: groupItems
            }
        });
    });
    return items;
}

const LayerSwitcher = (props) => {

    let onMenuItemClick = (event, item) => {
        if (item.layer.base) {
            setBaseLayerVisibility(props.layers, item.layer, props.moduleActions.setLayerVisibility);
        } else {
            setOverLayerVisibility(props.layers, item.layer, props.moduleActions.setLayerVisibility);
        };
    };

    return (
        <DefaultButton
            text="Seznam vrstev"
            menuProps={{items: getMenuProps(props.layers, props.groups, onMenuItemClick)}}
            iconProps={{iconName: 'MapLayers'}}
            allowDisabledFocus
        />
    );
};

export default LayerSwitcher;
